import type { ReactNode } from "react";

const MARKS = /`([^`]+)`|\[([^\]]+)\]\(([^)\s]+)\)/g;

/** The site's own copy: `code`, and [links](/developers/ask) whose text may hold code. Nothing else is markup. */
export function inline(text: string): ReactNode[] {
  const out: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(MARKS)) {
    const at = m.index ?? 0;
    if (at > last) out.push(text.slice(last, at));
    if (m[1] !== undefined) {
      out.push(<code key={at}>{m[1]}</code>);
    } else if (m[3]!.startsWith("/")) {
      out.push(
        <a key={at} href={m[3]}>
          {inline(m[2]!)}
        </a>
      );
    } else {
      out.push(
        <a key={at} href={m[3]} target="_blank" rel="noreferrer">
          {inline(m[2]!)}
        </a>
      );
    }
    last = at + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export function Prose({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return <p className={className}>{inline(text)}</p>;
}
